<template>
  <BaseEditModal
    displayName="Proactive Issue Detection"
    icon="mdi-bug-check-outline"
    hideBottomButtons
    :hideTabs="true"
    :masterObj="{}"
    :tabs="tabs"
    @close="emit('close')">
    <template v-slot:prepend-buttons>
      <v-btn
        variant="flat"
        @click="
          denyTelemetry();
          emit('close');
        ">
        Disable
      </v-btn>
    </template>
    <template v-slot:append-buttons>
      <v-btn
        color="primary"
        variant="flat"
        @click="
          acceptTelemetry();
          emit('close');
        ">
        <v-icon class="mr-2">mdi-check-circle</v-icon>
        Accept
      </v-btn>
    </template>
  </BaseEditModal>
</template>
<script setup lang="ts">
import TelemetryMessage from './TelemetryMessage.vue';
import BaseEditModal from '@/components/Shared/Modals/BaseEditModal.vue';
import { $http } from '@/stores/http.js';
import { state } from '@/stores/deluge.js';
const emit = defineEmits({
  close: () => true,
  override: (override: boolean) => override,
});
async function acceptTelemetry() {
  await $http('POST', '/telemetry?accept=true');
  localStorage.setItem('userConsent', 'true');
  state.current_user.extra_info.user_consent = true;
}
async function denyTelemetry() {
  await $http('POST', '/telemetry?accept=false');
  localStorage.removeItem('userConsent');
  state.current_user.extra_info.user_consent = false;
}
const tabs = [
  {
    id: 0,
    title: 'System Data Usage',
    icon: 'mdi-bug-check-outline',
    display: true,
    component: TelemetryMessage,
  },
];
</script>
<style scoped></style>
